import { Cookie } from '@tools/cookie';
import { Logger } from '@tools/logger/logger';
import { Storage } from '@tools/storage/storage';
import { ORIGIN_FAVORITE, UserOrigin } from '@tools/user/origin';
import { URL_OFFER_FAVORITE_SET, URL_SELECTION_ITEM_LIST } from '@tools/routes/routes';
import { KEY_USER_CALLBACK } from '@tools/storage/keys';
import { eventBus } from '@tools/event-bus';
import { flashBagSuccess } from '@tools/flashbag.ts';
import { trans } from '@elements/translation';
import { FAVORITE_PROPOSAL_EVENT } from './constants';

/**
 * Store requested offer id, so we'll be able to
 * save it upon login/registration and trigger login tunnel
 */
export const storeCallbackAndDoLogin = (
  favorite: boolean,
  hashId: string,
): void => {
  const storage = new Storage(Cookie);
  storage.setJSON(
    KEY_USER_CALLBACK,
    {
      callbackEvent: 'favorite',
      favorite,
      offerId: hashId,
    },
    1 / 144,
  );
  eventBus.dispatchEvent(new Event('close-modal'));
  UserOrigin.set(ORIGIN_FAVORITE, { offer_id: hashId });
  eventBus.dispatchEvent(new CustomEvent('start-entry-tunnel', { detail: window.location.href }));
};

interface CallSetFavoriteApiParams {
    detail: {
        offerHashId: string,
        isActive: boolean,
        offerTeamSizes?: unknown[],
        teamSize?: number,
    };
}

async function callSetFavoriteApi({
  detail: { offerHashId, isActive, offerTeamSizes, teamSize },
}: CallSetFavoriteApiParams): Promise<void> {
  try {
    const response = await fetch(URL_OFFER_FAVORITE_SET.replace('{id}', offerHashId), {
      method: 'POST',
      body: JSON.stringify({
        favorite: isActive,
        offerTeamSizes,
        teamSize,
      }),
    });

    if (response.status === 401) {
      storeCallbackAndDoLogin(isActive, offerHashId);
      return;
    }

    if (!response.ok) {
      throw new Error('Favorite backend call, response nok');
    }

    const { favorite }: { favorite: boolean } = await response.json();

    if (favorite) {
      flashBagSuccess(
        trans('favorite.add.flashbag', { selectionUrl: URL_SELECTION_ITEM_LIST }),
        7000,
      );
    }

    eventBus.dispatchEvent(new CustomEvent(FAVORITE_PROPOSAL_EVENT.OFFER_FAVORITE_TOGGLE_CALLBACK, {
      detail: { offerHashId, favorite },
    }));
  } catch (error) {
    Logger.error(error);
  }
}

export const init = (): void => {
  eventBus.addEventListener(FAVORITE_PROPOSAL_EVENT.OFFER_FAVORITE_TOGGLE, callSetFavoriteApi);
};
